import { useState, useEffect } from 'react';
import { useChatContext } from 'stream-chat-react';

const LOADED = null;
// returns a loading boolean for the ChannelList channels query.
// State is considered to be loading if the query is in any state beside LOADED.
const useChannelsLoading = () => {
    const [loading, setLoading] = useState(true);
    const { channelsQueryState } = useChatContext("ChannelList");
    const { queryInProgress: queryState } = channelsQueryState;
    useEffect(() => {
        setLoading(queryState != LOADED);
    }, [queryState]);
    return loading;
};

export { useChannelsLoading };
//# sourceMappingURL=use_channels_loading.js.map
